<template>
    <div>
        <el-dialog :visible.sync="visible" title="提交审核" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form
                    ref="approveRef"
                    :model="approveForm"
                    label-width="200px"
                    style="text-align: left;">
                <el-form-item
                        v-for="(item, index) in approveList"
                        :key="index"
                        :label="`${item.jobName}：`"
                        required>
                    <el-input style="width: 70%;" v-model="item.approveUserName" clearable></el-input>
                    <el-button @click="selectApproveTarget(item)" type="primary">选择</el-button>
                </el-form-item>
            </el-form>
            <el-footer class="container">
                <div class="btnMid">
                    <el-button type="info" @click="visible = false">取 消</el-button>
                    <el-button type="primary" @click="submitBtn()">确 认</el-button>
                </div>
            </el-footer>
        </el-dialog>
        <approve-dialog
                :visible="approveDialogVisible"
                @close="approveDialogClose"
                title="选择审批人员"
                v-bind="approveDialogOptions"
        ></approve-dialog>
    </div>
</template>

<script>
    import Consts from "@/utils/consts";
    import ApproveDialog from "../meeting/bill/ApproveDialog";
    import { getApproveListService } from '../../services/sysSettingService'
    import  {
        createApproveProcessService,
        saveFrontService,
        saveMiddleService,
    } from '../../services/engineering'
    export default {
        name: "submit-review",
        data () {
            return {
                visible: false,

                id: '',
                projectId: '',
                title: '',
                documentNum: '',
                row: null,
                actualEngineerList: [],

                titleIndex: 1,
                approveForm: {
                    headOfDepart: {
                        // 部门负责人
                        id: null,
                        name: "",
                    },
                    leaderOfCompany: {
                        // 集团分管领导
                        id: null,
                        name: "",
                    },
                }, // 审批流程
                approveList: [], // 审批流列表

                approveDialogVisible: false,
                approveDialogOptions: {
                    approveVO: {},
                }, // 审批流弹出框的配置
            }
        },
        components: {
            ApproveDialog,
        },
        methods:{
            init(){
                this.visible = true;
                this.$nextTick(()=> {
                    this.getApproveDetail();
                })
            },
            // 获取审批信息
            getApproveDetail(){
                let params = {
                    orgId: sessionStorage.getItem("orgId"),
                    type: this.titleIndex == 1? "beforehand":'inTheMatter',
                };
                getApproveListService(params)
                    .then((res) => {
                        if (res.code == Consts.Code_OK) {
                            let list = res.data || [];
                            list.forEach((item) => {
                                item.approveUserId = null;
                                item.approveUserName = "";
                                item.deptId = null;
                                item.deptName = "";
                                item.sort = item.sortId;
                            });
                            list.sort((a, b) => {
                                return a.sortId - b.sortId;
                            }); // 按照sortId排序，从小到大
                            this.approveList = [...list];
                        } else if (res.code == Consts.Code_Err) {
                            this.$alert(res.msg, "提示");
                        } else {
                            this.$alert(Consts.Err_Msg, "提示");
                        }
                    })
                    .catch((error) => {
                        this.$message.error(Consts.Err_Msg);
                    });
            },
            selectApproveTarget(item) {
                // 选择对应的审批人
                this.approveDialogOptions = {
                    approveVO: item,
                };
                this.approveDialogVisible = true;
            },
            approveDialogClose(data) {
                console.log("审批流程,关闭", data);
                this.approveDialogVisible = false;
                if (data) {
                    // 选了人了
                    this.approveList.forEach((item) => {
                        if (item.jobId == data.jobId) {
                            item.approveUserId = data.id;
                            item.approveUserName = data.displayName || data.name;
                            item.deptId = data.deptId;
                             item.deptName = data.deptDisplayName;
                            // item.jobId = data.jobId;
                            // item.jobName = data.jobName;
                        }
                    });
                }
            },
            submitBtn(){
                let isApprove = this.approveList.findIndex(item => item.approveUserId == null || item.approveUserId == ''|| item.approveUserName == '')
                if(isApprove != -1){
                    this.$message.error('请完善审批流程');
                    return
                }
                if(this.titleIndex == 1){
                    this.saveFront();
                }else{
                    this.saveMiddle();
                }
            },
            //事前细目更新
            saveFront(){
                let  params = this.actualEngineerList[this.row.index]
                params.approveStatusEnum = 'UNDERAPLLY'
                saveFrontService(params).then( res => {
                    if(res.code == 10000000){
                        this.createApprove();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //事中细目更新
            saveMiddle(){
                let obj = this.actualEngineerList[this.row.index]
                let params = {
                    ...obj
                }
                params.approveStatusEnum = 'UNDERAPLLY'
                params.laborActList = [];
                params.machineActList = [];
                params.materialActList = [];
                params.otherActList = [];
                obj.partyActList.map(item => {
                    params.laborActList = [...params.laborActList,...item.laborActList]
                    params.machineActList = [...params.machineActList,...item.machineActList]
                    params.materialActList = [...params.materialActList,...item.materialActList]
                    params.otherActList = [...params.otherActList,...item.otherActList]
                })
                saveMiddleService(params).then( res => {
                    if(res.code == 10000000){
                        this.createApprove();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //创建审批流
            createApprove(){
                let params = {
                    approveClass: this.titleIndex == 1? "PROJECT_FRONT":'PROJECT_MIDDLE',
                    approveProcessDtoList: this.approveList,
                    approveStatusEnum:'UNDERAPLLY',
                    projectId: this.projectId,
                    itemId: this.id,
                    itemName: `${sessionStorage.getItem('name')}关于${this.title}${this.documentNum}的${this.titleIndex == 1?'事前':'事中'}申请`,
                }
                createApproveProcessService(params).then((res) => {
                    if (res.code == Consts.Code_OK) {
                        this.$message.success('提交审核成功');
                        this.$emit('refreshDataList')
                        this.visible = false;
                    } else if (res.code == Consts.Code_Err) {
                        this.$alert(res.msg, "提示");
                    } else {
                        this.$alert(Consts.Err_Msg, "提示");
                    }
                }).catch((error) => {
                    this.$message.error(Consts.Err_Msg);
                });
            }
        }
    }
</script>

<style scoped>
    /deep/.el-dialog{
        width: 45%;
    }
    .txt{
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
    }
    .container{
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
</style>
